import { render } from "./MWTest.vue?vue&type=template&id=5dbc3f6d"
import script from "./MWTest.vue?vue&type=script&lang=js"
export * from "./MWTest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__